export default __webpack_public_path__ + "static/media/email.ccd33ba1.svg";